import { get } from 'lodash';
import {
	SUBMIT_GET_EXCHANGE_RATES_FAILURE,
	SUBMIT_GET_EXCHANGE_RATES_SUCCESS,
	SUBMIT_GET_EXCHANGE_RATES_REQUEST,
} from './actions';

export const initialState = {
	isRatesApiInProgress: false,
	error: undefined,
};

const rates = (state = initialState, action) => {
	if (action.type === SUBMIT_GET_EXCHANGE_RATES_REQUEST && get(action, 'error', false)) {
		return {
			...state,
			error: get(action, 'error', false),
			isRatesApiInProgress: false,
		};
	}
	switch (action.type) {
		case SUBMIT_GET_EXCHANGE_RATES_FAILURE: {
			return { ...state, isRatesApiInProgress: false, error: action.payload };
		}
		case SUBMIT_GET_EXCHANGE_RATES_SUCCESS: {
			return { ...state, error: undefined, isRatesApiInProgress: false };
		}
		case SUBMIT_GET_EXCHANGE_RATES_REQUEST: {
			return { ...state, error: undefined, isRatesApiInProgress: true };
		}

		default:
			return state;
	}
};

export default rates;
